module.exports = __webpack_public_path__ + "static/media/5.5_preview.d9ca5952.png";